import { render, staticRenderFns } from "./master.vue?vue&type=template&id=141fd2c8&scoped=true"
import script from "./master.vue?vue&type=script&lang=js"
export * from "./master.vue?vue&type=script&lang=js"
import style0 from "./master.vue?vue&type=style&index=0&id=141fd2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141fd2c8",
  null
  
)

export default component.exports